<template>
  <div class="chartWrapper">
    <div v-if="loaded == false">
      <p style="padding-top: 100px">
        <center>
          <div class="fa-3x">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
          Cargando datos
        </center>
      </p>
    </div>
    <div v-else id="wrapper">
      <!-- Titulos -->
      <b-row style="zoom: 0.9">
        <b-col cols="8">
          <p style="padding-left: 10px">
            Seleccionar un intervalo personalizado
          </p>
        </b-col>
        <b-col>
          <p style="padding-left: 10px">
            Seleccione un intervalo preestablecido
          </p>
        </b-col>
      </b-row>
      <!-- Opciones -->
      <b-row style="zoom: 0.9; padding-left: 15px">
        <b-col cols="8" class="selectGroup">
          <b-row>
            <b-col align="middle">
              <p class="intervalo" style="margin-left: 10px">
                Inicio de intervalo
              </p>
              <VueCtkDateTimePicker
                v-model="datePickerValueInit"
                format="YYYY-MM-DD HH:mm"
                label="Inicio de intervalo"
                disabled="true"
              />
            </b-col>
            <b-col align="middle">
              <p class="intervalo" style="margin-left: 10px">
                Fin del intervalo
              </p>
              <VueCtkDateTimePicker
                v-model="datePickerValueEnd"
                format="YYYY-MM-DD HH:mm"
                label="Fin de intervalo - Seleccione fecha y hora"
                button-now-translation="Ahora"
                @is-hidden="selectDateTime()"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col class="text-center">
          <div class="selectGroup">
            <b-button
              variant="primary"
              pill
              @click="updateData('one_hour')"
              :pressed="serverParams.graphFilters.windowSize === 'one_hour'"
              title="Intervalo de 1 hora"
              class="boton"
            >
              <span class="text-uppercase">Hora</span>
            </b-button>

            <b-button
              variant="primary"
              pill
              @click="updateData('one_day')"
              :pressed="serverParams.graphFilters.windowSize === 'one_day'"
              title="Intervalo de 1 día"
              class="boton"
            >
              <span class="text-uppercase">Día</span>
            </b-button>

            <b-button
              variant="primary"
              pill
              @click="updateData('one_week')"
              :pressed="serverParams.graphFilters.windowSize === 'one_week'"
              title="Intervalo de 1 semana"
              class="boton"
            >
              <span class="text-uppercase">Semana</span>
            </b-button>

            <b-button
              variant="primary"
              pill
              @click="updateData('one_month')"
              :pressed="serverParams.graphFilters.windowSize === 'one_month'"
              title="Intervalo de 1 mes"
              class="boton"
            >
              <span class="text-uppercase">Mes</span>
            </b-button>
          </div>
        </b-col>
      </b-row>

      <!-- Init carousel -->
      <b-row style="min-height: 250px; padding: 10px">
        <b-col
          cols="1"
          class="arrowLeft"
          title="Cambiar a una fecha anterior"
          @click="getPreviousChart"
        >
          <p style="margin-top: 95px; position: absolute">
            <i class="fas fa-chevron-left fa-2x"></i>
          </p>
        </b-col>
        <b-col
          style="
            border-top: 1px solid rgba(0, 0, 0, 0.125);
            border-bottom: 1px solid rgba(0, 0, 0, 0.125);
          "
        >
          <!-- Init GRafica pura -->
          <div>
            <div class="chartWrapper">
              <div v-if="loaded == false">
                <p style="padding-top: 200px">
                  <center>
                    <div class="fa-3x">
                      <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    Cargando datos
                  </center>
                </p>
              </div>
              <apexchart
                ref="chartfreq"
                v-if="loaded"
                height="350"
                width="100%"
                type="line"
                class="decorativeBox"
                :options="chartOptions"
                :series="series"
              ></apexchart>
            </div>
          </div>
          <!-- End GRafica pura -->
        </b-col>
        <b-col
          cols="1"
          class="arrowRight"
          title="Cambiar a una fecha posterior"
          @click="getNextChart"
        >
          <p style="margin-top: 95px; position: absolute">
            <i class="fas fa-chevron-right fa-2x"></i>
          </p>
        </b-col>
      </b-row>
      <!-- End Carousel -->
    </div>
  </div>
</template>


<script>
import GroupService from "@/services/GroupService";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  name: "freq-chart",
  components: {
    VueCtkDateTimePicker: VueCtkDateTimePicker,
  },
  data() {
    return {
      loaded: false,
      datePickerValueEnd: "",
      selectedID: null,
      position: 0, //cargar última gráfica por defecto
      serverParams: {
        graphFilters: {
          windowSize: "one_hour",
          windowEnd: Date.now(),
        },
        limit: 0,
      },
      datacollection: {
        agrupacion: "",
        fecha: "",
      },
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: true,
          },
        },
        title: {
          text: "",
          align: "center",
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "13px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        stroke: {
          curve: "straight",
        },
        tooltip: {
          enabled: true,
          shared: false,
          followCursor: false,
          x: {
            show: true,
            format: "dd/MM/yy HH:mm:ss.ff",
          },
          y: {
            formatter: undefined,
            title: {
              formatter: (seriesName) => seriesName,
            },
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
      },
    };
  },
  computed: {
    // un getter computado
    datePickerValueInit: function () {
      var rValue = null;

      if (this.serverParams.graphFilters.windowSize === "one_hour") {
        rValue = this.$moment(this.datePickerValueEnd).add(-1, "hours");
        //this.options.scales.xAxes[0].time.unit = "minute";
      } else if (this.serverParams.graphFilters.windowSize === "one_day") {
        rValue = this.$moment(this.datePickerValueEnd).add(-1, "days");
        //this.options.scales.xAxes[0].time.unit = "hour";
      } else if (this.serverParams.graphFilters.windowSize === "one_week") {
        rValue = this.$moment(this.datePickerValueEnd).add(-1, "week");
        //this.options.scales.xAxes[0].time.unit = "day";
      } else if (this.serverParams.graphFilters.windowSize === "one_month") {
        rValue = this.$moment(this.datePickerValueEnd).add(-1, "months");
        //this.options.scales.xAxes[0].time.unit = "week";
      }

      return rValue;
    },
  },
  methods: {
    // Evento para seleccionar la fecha
    ///////////////////////////////////

    async calcWindowsLimit(position) {
      var rValue = null;

      if (this.serverParams.graphFilters.windowSize === "one_hour") {
        rValue = this.$moment(this.datePickerValueInit).add(position, "hours");
        //this.options.scales.xAxes[0].time.unit = "minute";
      } else if (this.serverParams.graphFilters.windowSize === "one_day") {
        rValue = this.$moment(this.datePickerValueInit).add(position, "days");
        //this.options.scales.xAxes[0].time.unit = "hour";
      } else if (this.serverParams.graphFilters.windowSize === "one_week") {
        rValue = this.$moment(this.datePickerValueInit).add(position, "week");
        //this.options.scales.xAxes[0].time.unit = "day";
      } else if (this.serverParams.graphFilters.windowSize === "one_month") {
        rValue = this.$moment(this.datePickerValueInit).add(position, "months");
        //this.options.scales.xAxes[0].time.unit = "week";
      }


      this.datePickerValueEnd = rValue;
      this.serverParams.graphFilters.windowEnd = await rValue;
    },

    selectDateTime: function () {
      this.updateWindowEnd();
    },

    async updateWindowEnd() {
      if (this.datePickerValueEnd) {
        this.serverParams.graphFilters.windowEnd = this.datePickerValueEnd;
      } else {
        this.serverParams.graphFilters.windowEnd = new Date(
          Date.now()
        ).toString();
      }

      await this.retrieveChartFreq(this.selectedID);
    },

    async updateData(timeline) {
      this.serverParams.graphFilters.windowSize = timeline;
      await this.retrieveChartFreq(this.selectedID);
    },
    ////////////////////////////////////
    ////////////////////////////////////

    // PUNTO DE ENTRADA EXTERNO
    // PARA POPULAR LAS GRAFICAS A PARTIR DEL ULTIMO DATO
    /////////////////////////////
    async createChartFreq(id) {
      if (id) {
        // Obtenemos el ultimo dato de la gráfica para autoconfigurar
        // las gráficas desde el ultimo punto
        this.serverParams.limit = 1;
        await GroupService.getFreq(id, this.serverParams)
          .then(async (response) => {
            if (response.data) {
              this.datePickerValueEnd = this.$moment(response.data);
              this.serverParams.graphFilters.windowEnd =
                this.datePickerValueEnd;
              await this.retrieveChartFreq(id);
            } else {
              this.datePickerValueEnd = this.$moment(
                new Date(Date.now()).toISOString()
              );
              this.serverParams.graphFilters.windowEnd =
                this.datePickerValueEnd;
              await this.retrieveChartFreq(id);
            }
          })
          .catch((e) => {
            console.log("Error recuperando ultimo dato de la gráfica");
            console.log(e);
          });
      }
    },

    //Pedir la siguiente terna de datos
    async getNextChart() {
      this.position++;      
      await this.calcWindowsLimit(this.position);
      await this.retrieveChartFreq(this.selectedID);
    },

    //Pedir la terna anterior de datos
    async getPreviousChart() {
      if (this.position <= 0) {
        this.position = 0;
      } else {
        this.position--;
      }      
      await this.calcWindowsLimit(this.position);
      await this.retrieveChartFreq(this.selectedID);
    },

    // SOLICITAR DATOS PARA LAS GRAFICAS APEXCHARTS
    //////////////////////////////////////////////
    async retrieveChartFreq(id) {
      this.loaded = false;

      if (id) {
        // Pedimos la gráfica ahora con todos los datos uan vez
        // que se ha autoconfigurado todo y comprobando que no estamos mandadno
        // un valor final no populado
        if (this.datePickerValueEnd != "") {
          this.serverParams.limit = 0; //Obtener todos los registros
          await GroupService.getFreq(id, this.serverParams)
            .then((response) => {
              this.selectedID = id;

              if (response.data && response.data.series) {
                console.log(response.data);
                this.series = response.data.series;
                //this.chartOptions.title.text = response.data.fecha;
              } else {
                this.series = [
                  {
                    name: "Freq 1",
                    data: [],
                  },
                  {
                    name: "Freq 2",
                    data: [],
                  },
                  {
                    name: "Freq 3",
                    data: [],
                  },
                  {
                    name: "Freq 4",
                    data: [],
                  },
                  {
                    name: "Freq 5",
                    data: [],
                  },
                  {
                    name: "Freq 6",
                    data: [],
                  },
                  {
                    name: "Freq 7",
                    data: [],
                  },
                  {
                    name: "Freq 8",
                    data: [],
                  },
                ];
              }

              this.loaded = true;
            })
            .catch((e) => {
              this.loaded = true;
              console.log("Error recuperando datos de la grafica");
              console.log(e);
            });
        }
      } else {
        this.series = [
          {
            name: "Freq 1",
            data: [],
          },
          {
            name: "Freq 2",
            data: [],
          },
          {
            name: "Freq 3",
            data: [],
          },
          {
            name: "Freq 4",
            data: [],
          },
          {
            name: "Freq 5",
            data: [],
          },
          {
            name: "Freq 6",
            data: [],
          },
          {
            name: "Freq 7",
            data: [],
          },
          {
            name: "Freq 8",
            data: [],
          },
        ];
        this.loaded = true;
      }
    },
  },
  async created() {
    this.datePickerValueEnd = this.$moment();
  },
};
</script>

<style scoped>
.titulo {
  position: absolute;
  margin-top: -55px;
  margin-left: 340px;
  font-size: 0.95rem;
  color: #606266;
  text-align: center;
  font-weight: 400;
}

.agrupacionTitulo {
  font-weight: 500;
}

.fecha {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 20px;
  font-size: 0.8rem;
  color: #606266;
}

.fechaTitulo {
  margin-left: 30px;
  font-weight: 500;
}

#measureChartFrame {
  width: 100%;
}

.toolbar {
  margin-top: 10px;
}

div.toolbar button span {
  font-size: 12px;
  font-weight: bold;
  margin-left: 5px;
}

div.toolbar button {
  margin-right: 5px;
}

.date-time-picker {
  width: 300px !important;
  margin: 0 !important;
}

.labelSeparator {
  margin-top: 10px;
}

.containerDateTime {
  padding-top: 10px;
  text-align: left;
}

#measureChartFrame {
  width: 100%;
}

div.toolbar button span {
  font-size: 12px;
  font-weight: bold;
  margin-left: 5px;
}

div.toolbar button {
  margin-right: 5px;
}

.date-time-picker {
  width: 300px !important;
  margin: 0 !important;
}

.labelSeparator {
  margin-top: 10px;
}

.containerDateTime {
  padding-top: 10px;
  text-align: left;
}

.chartWrapper {
  margin-top: 20px;
  padding: 10px;
}

.selectGroup {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 10px;
  height: 88px;
}

.boton {
  margin: 15px 2px 2px 2px;
  font-size: 0.85rem;
}

.intervalo {
  margin: 0px !important;
  text-align: left;
  padding-left: 35px;
  font-size: 0.9rem;
}

.decorativeBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
}
</style>


<style scoped>
.list-group-item {
  border: 0px !important;
  padding: 5px 5px 5px 60px !important;
}

.arrowLeft {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem 0rem 0rem 0.25rem;
  cursor: pointer;
  max-width: 50px !important;
  padding: 90px 0px 0px 15px !important;
  background-color: rgb(243, 242, 242);
}

.arrowLeft:hover {
  background-color: rgb(236, 235, 235);
}

.arrowRight {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0rem 0.25rem 0.25rem 0rem;
  cursor: pointer;
  max-width: 50px !important;
  padding: 90px 0px 0px 15px !important;
  background-color: rgb(243, 242, 242);
}

.arrowRight:hover {
  background-color: rgb(236, 235, 235);
}

.tituloAlt {
  font-size: 0.95rem;
  color: #606266;
  font-weight: 400;
}

.selSensor {
  padding: 3px;
  font-size: 0.95rem;
  color: #606266;
  font-weight: 400;
}
</style>